import React, { useState } from "react";
import { Play, Trash2, Settings } from "lucide-react";
import { NodeActionsProps } from "../../../../pages/journey/types";

export const NodeActions: React.FC<NodeActionsProps> = ({ 
  node, 
  onDelete, 
  onAddNode, 
  visible 
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const shouldShow = visible || isHovered;

  if (!shouldShow) return null;

  return (
    <div 
      className="absolute -top-12 left-1/2 transform -translate-x-1/2 flex items-center space-x-1 bg-white border border-gray-200 rounded-lg shadow-lg p-1 z-20"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <button
        onClick={(e) => {
          e.stopPropagation();
          // Play action would go here
        }}
        className="p-1 hover:bg-gray-100 rounded transition-colors"
        title="Test node"
      >
        <Play className="w-4 h-4 text-gray-600" />
      </button>
      
      <button
        onClick={(e) => {
          e.stopPropagation();
          // Settings action would go here
        }}
        className="p-1 hover:bg-gray-100 rounded transition-colors"
        title="Configure"
      >
        <Settings className="w-4 h-4 text-gray-600" />
      </button>
      
      {node.type !== "trigger" && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onDelete();
          }}
          className="p-1 hover:bg-red-50 rounded transition-colors"
          title="Delete node"
        >
          <Trash2 className="w-4 h-4 text-red-600" />
        </button>
      )}
    </div>
  );
};